export function dataMapperForUI(data) {
  const buyer = {};
  const target = {};
  buyer.companyName = data.buyer.companyName;
  buyer.tableContent = data.table[0].buyer;

  target.companyName = data.target.companyName;
  target.tableContent = data.table[0].target;
  return [buyer, target];
}

export function dataForRedux(data) {
  const buyer = { executives: [] };
  const target = { executives: [] };

  buyer.executives = data.table[0].buyer;
  target.executives = data.table[0].target;

  return { buyer, target };
}
